/** Shared human controls keep QA-failed and pending approvals on the same feedback/memory path. */
import { ApprovalActions } from "./CreativeBits";

export function DecisionActions({ brandId, creativeId, status, size = "sm", className }: { brandId: string; creativeId: string; status: string; size?: "xs" | "sm" | "md"; className?: string }) {
  if (status !== "pending_approval" && status !== "qa_failed") return null;
  return <ApprovalActions brandId={brandId} creativeId={creativeId} size={size} className={className} qaFailed={status === "qa_failed"} />;
}
